var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HDSInput } from "@here/hds-react-components/Input";
import { HDSButton } from "@here/hds-react-components/Button";
import { useEffect, useState } from "react";
import "./searchBox.scss";
import translations from "../../translations/resources/en-GB.json";
import { useDispatch, useSelector } from "react-redux";
import { setUploadStatus } from "../../store/reducers/appSlice";
import { useHistory } from "react-router-dom";
var SearchBox = function (_a) {
    var _b = _a.secondarySearchButtonName, secondarySearchButtonName = _b === void 0 ? translations.data["venonboard.searchComponent.button.SearchMaps"] : _b, ref = _a.ref, onChange = _a.onChange, searchText = _a.searchText;
    var dispatch = useDispatch();
    var history = useHistory();
    var selectedTab = useSelector(function (state) { return state.app.selectedTab; });
    var isNoMap = useSelector(function (state) { return state.app.isNoMap; });
    var _c = useState(""), searchBoxInput = _c[0], setSearchBoxInput = _c[1];
    var searchBoxInputChange = function (e) {
        if (e.detail.value !== "") {
            setSearchBoxInput(e.detail.value);
            onChange && onChange(e.detail.value);
        }
        else {
            setSearchBoxInput("");
            onChange && onChange("");
        }
    };
    var mapOrderFunctionality = function () {
        dispatch(setUploadStatus(null));
        history.push({
            pathname: "/mapOrders",
            search: window.location.search,
        });
    };
    useEffect(function () {
        setSearchBoxInput("");
        onChange && onChange("");
    }, []);
    useEffect(function () {
        setSearchBoxInput("");
    }, [dispatch, selectedTab]);
    return (_jsxs("div", __assign({ className: "searchBoxBar" }, { children: [_jsxs("div", __assign({ className: "searchBoxContainer" }, { children: [_jsx("span", __assign({ className: "searchBoxArea" }, { children: _jsx(HDSInput, { ref: ref, name: "", iconCategory: "core-ui", type: "search", placeholder: translations.data["venonboard.searchComponent.searchInput.placeholder"], "data-cy": "searchbox", style: { width: "19rem" }, size: "medium", id: "search-maps", "data-test": "search-indoor-maps", "aria-label": translations.data["venonboard.searchComponent.searchInput"], icon: "search", value: searchBoxInput || searchText, onKeyUp: function (e) {
                                if (e.key === "Enter" && searchBoxInput !== "") {
                                    onChange && onChange(searchBoxInput);
                                }
                            }, onChange: function (e) { return searchBoxInputChange(e); }, disabled: isNoMap }) })), selectedTab === "indoorMap" && (_jsx("div", __assign({ onClick: function () {
                            onChange(searchBoxInput);
                        }, "data-cy": "search-button" }, { children: _jsx(HDSButton, __assign({ id: "search-button", size: "medium", type: "button", variant: "secondary", width: "100px" }, { children: secondarySearchButtonName })) })))] })), selectedTab === "indoorMap" && (_jsx("div", __assign({ className: "mapOrderButton", onClick: mapOrderFunctionality }, { children: _jsx(HDSButton, __assign({ id: "order-new-maps-button", size: "medium", type: "button", variant: "primary", width: "129px", "data-cy": "order-new-maps-button" }, { children: translations.data["venonboard.searchComponent.button.NewMapOrders"] })) })))] })));
};
export default SearchBox;
